import React from 'react';
import { Button, Container, Table } from '@codeparva/ui-components-library';
import { ThankYouPageTypes } from './ThankYouPageTypes';

export const ThankYouPage = ({
  completionMessage,
  thankYouMessage,
  contactMessage,
  confirmationDetails,
  queryMessage,
  eSignToken = '',
  receipt_url = '',
}: ThankYouPageTypes.IThankYouPage) => {
  const getEsignUrl = () => {
    return `${process.env.GATSBY_ESIGN_BASE_URL}${eSignToken}`;
  };

  const downloadReceipt = () => {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', receipt_url);
    link.setAttribute('download', 'receipt.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <Container className="thankYou has-text-centered">
      {completionMessage && (
        <h4 className="completionMessage has-text-weight-bold">
          {completionMessage}
        </h4>
      )}
      {thankYouMessage && (
        <h5 className="thankYouMessage has-text-weight-bold my-3">
          {thankYouMessage}
        </h5>
      )}
      {contactMessage && (
        <div
          dangerouslySetInnerHTML={{ __html: contactMessage }}
          className="mb-3"
        ></div>
      )}
      <Table
        className="has-text-left is-flex is-justify-content-center"
        bordered={false}
      >
        <tbody>
          {Object.entries(confirmationDetails).map(([key, value]) => {
            return (
              value && (
                <tr data-testid={`payment-${key}`}>
                  <td className="has-text-text">{key}</td>
                  <td className="has-text-text">{value}</td>
                </tr>
              )
            );
          })}
        </tbody>
      </Table>
      {queryMessage && (
        <p className="queryMessage mb-6 subtitle1">{queryMessage}</p>
      )}
      <div className="buttonDiv">
        <span className="callToActionButton">
          {receipt_url && (
            <Button
              className="cp-outline-button-highlighted"
              onClick={downloadReceipt}
            >
              Download Receipt
            </Button>
          )}
        </span>
        <span className="esignButton">
          {eSignToken && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={getEsignUrl()}
              className="has-text-white"
            >
              <Button className="cp-primary-button-highlighted">
                Sign the lease
              </Button>
            </a>
          )}
        </span>
      </div>
    </Container>
  );
};
